// frontend/src/Recursos.js
// Sección de Recursos con tabs interactivas - LOPDP Ecuador

import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
  FaUsers,
  FaFileContract,
  FaShieldAlt,
  FaExclamationTriangle,
  FaBuilding,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaRocket,
  FaEye,
  FaHeart,
  FaHandshake,
  FaLock,
  FaUserCheck,
  FaDatabase,
  FaClock,
  FaGlobe,
  FaCheckCircle,
  FaBell,
  FaEdit,
  FaTrash,
  FaBan,
  FaExchangeAlt,
  FaRobot
} from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Recursos.css';

function Recursos() {
  const [activeTab, setActiveTab] = useState('about');

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  const tabs = [
    { id: 'about', label: 'Quienes Somos', icon: FaUsers },
    { id: 'terms', label: 'Terminos de Uso', icon: FaFileContract },
    { id: 'privacy', label: 'Politica de Privacidad', icon: FaShieldAlt },
    { id: 'disclaimer', label: 'Disclaimer', icon: FaExclamationTriangle }
  ];

  // ═══════════════════════════════════════════════════════════════
  // CONTENIDO: QUIENES SOMOS
  // ═══════════════════════════════════════════════════════════════
  const AboutContent = () => (
    <div className="tab-content-inner" data-aos="fade-up">
      {/* Header de la empresa */}
      <div className="content-header">
        <div className="company-logo">
          <FaBuilding className="logo-icon" />
        </div>
        <h2 className="content-title">UrbanQ - Smart Living</h2>
        <p className="content-subtitle">NextUnicode Corp</p>
        <p className="tagline">"Smart living, Ecuadorian soul"</p>
      </div>

      {/* Mision y Vision */}
      <Row className="g-4 mt-4">
        <Col lg={6}>
          <div className="info-card mission-card">
            <div className="card-icon-wrapper">
              <FaRocket className="card-icon" />
            </div>
            <h3>Nuestra Mision</h3>
            <p>
              Transformar la gestion de condominios en Ecuador mediante tecnologia
              intuitiva, facilitando la comunicacion entre administradores y residentes,
              y promoviendo comunidades mas conectadas y eficientes.
            </p>
          </div>
        </Col>
        <Col lg={6}>
          <div className="info-card vision-card">
            <div className="card-icon-wrapper cyan">
              <FaEye className="card-icon" />
            </div>
            <h3>Nuestra Vision</h3>
            <p>
              Ser la plataforma lider en administracion de comunidades residenciales
              en Latinoamerica, reconocida por nuestra innovacion, confiabilidad y
              compromiso con la excelencia en el servicio.
            </p>
          </div>
        </Col>
      </Row>

      {/* Valores */}
      <div className="values-section mt-5">
        <h3 className="section-subtitle">Nuestros Valores</h3>
        <Row className="g-3 mt-3">
          {[
            { icon: FaRocket, title: 'Innovacion', desc: 'Buscamos constantemente nuevas formas de mejorar' },
            { icon: FaEye, title: 'Transparencia', desc: 'Operamos con claridad y honestidad' },
            { icon: FaShieldAlt, title: 'Seguridad', desc: 'Protegemos tus datos como prioridad' },
            { icon: FaHeart, title: 'Compromiso', desc: 'Dedicados al exito de tu comunidad' }
          ].map((value, index) => (
            <Col md={6} lg={3} key={index}>
              <div className="value-item" data-aos="fade-up" data-aos-delay={index * 100}>
                <value.icon className="value-icon" />
                <h4>{value.title}</h4>
                <p>{value.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {/* Contacto */}
      <div className="contact-section mt-5">
        <h3 className="section-subtitle">Contactanos</h3>
        <Row className="g-3 mt-3">
          <Col md={4}>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>Quito, Ecuador</span>
            </div>
          </Col>
          <Col md={4}>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <span>admin@nextunicodecorp.com</span>
            </div>
          </Col>
          <Col md={4}>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <span>+593 99 534 6662</span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );

  // ═══════════════════════════════════════════════════════════════
  // CONTENIDO: TERMINOS DE USO
  // ═══════════════════════════════════════════════════════════════
  const TermsContent = () => (
    <div className="tab-content-inner legal-content" data-aos="fade-up">
      <div className="legal-sections">
        <section className="legal-section">
          <h3><FaHandshake className="section-icon" /> 1. Aceptacion de Terminos</h3>
          <p>
            Al acceder y utilizar la plataforma UrbanQ, usted acepta estar sujeto a estos
            Terminos de Uso. Si no esta de acuerdo con alguna parte de estos terminos,
            no podra acceder al servicio. Estos terminos aplican a todos los usuarios,
            visitantes y otras personas que accedan o utilicen el servicio.
          </p>
        </section>

        <section className="legal-section">
          <h3><FaBuilding className="section-icon" /> 2. Descripcion del Servicio</h3>
          <p>
            UrbanQ es una plataforma digital de gestion de condominios que permite a
            administradores y residentes gestionar pagos de alicuotas, comunicaciones,
            reservas de areas comunes, reportes de incidencias y otras funcionalidades
            relacionadas con la vida en comunidad.
          </p>
        </section>

        <section className="legal-section">
          <h3><FaUserCheck className="section-icon" /> 3. Registro y Cuenta de Usuario</h3>
          <ul>
            <li>Debe proporcionar informacion veraz y actualizada durante el registro</li>
            <li>Es responsable de mantener la confidencialidad de su contrasena</li>
            <li>Debe notificar inmediatamente cualquier uso no autorizado de su cuenta</li>
            <li>Una persona puede tener solo una cuenta por unidad habitacional</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3><FaCheckCircle className="section-icon" /> 4. Obligaciones del Usuario</h3>
          <ul>
            <li>Utilizar la plataforma de manera legal y etica</li>
            <li>No compartir credenciales de acceso con terceros</li>
            <li>Mantener actualizada la informacion de su perfil</li>
            <li>Respetar a otros usuarios en las comunicaciones</li>
            <li>Reportar cualquier vulnerabilidad o problema de seguridad</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3><FaBan className="section-icon" /> 5. Uso Permitido de la Plataforma</h3>
          <p>Esta prohibido:</p>
          <ul>
            <li>Usar la plataforma para actividades ilegales</li>
            <li>Intentar acceder a cuentas o datos de otros usuarios</li>
            <li>Enviar spam o contenido malicioso</li>
            <li>Modificar, adaptar o hackear el servicio</li>
            <li>Usar bots o scripts automatizados sin autorizacion</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3><FaShieldAlt className="section-icon" /> 6. Propiedad Intelectual</h3>
          <p>
            Todo el contenido, diseno, logotipos, codigo y materiales de UrbanQ son
            propiedad exclusiva de NextUnicode Corp. Esta prohibida su reproduccion,
            distribucion o modificacion sin autorizacion escrita previa.
          </p>
        </section>

        <section className="legal-section">
          <h3><FaExclamationTriangle className="section-icon" /> 7. Limitacion de Responsabilidad</h3>
          <p>
            UrbanQ no sera responsable por danos indirectos, incidentales o consecuentes
            derivados del uso de la plataforma. Nos esforzamos por mantener el servicio
            disponible 24/7, pero no garantizamos disponibilidad ininterrumpida.
          </p>
        </section>

        <section className="legal-section">
          <h3><FaEdit className="section-icon" /> 8. Modificaciones a los Terminos</h3>
          <p>
            Nos reservamos el derecho de modificar estos terminos en cualquier momento.
            Los cambios seran notificados a traves de la plataforma y/o por correo electronico.
            El uso continuado del servicio constituye aceptacion de los nuevos terminos.
          </p>
        </section>

        <section className="legal-section">
          <h3><FaGlobe className="section-icon" /> 9. Legislacion Aplicable</h3>
          <p>
            Estos terminos se rigen por las leyes de la Republica del Ecuador. Cualquier
            disputa sera resuelta por los tribunales competentes de la ciudad de Quito,
            Ecuador, renunciando las partes a cualquier otro fuero.
          </p>
        </section>

        <section className="legal-section">
          <h3><FaEnvelope className="section-icon" /> 10. Contacto para Consultas</h3>
          <p>
            Para preguntas sobre estos terminos, contactenos en:
            <strong> admin@nextunicodecorp.com</strong>
          </p>
        </section>
      </div>
    </div>
  );

  // ═══════════════════════════════════════════════════════════════
  // CONTENIDO: POLITICA DE PRIVACIDAD (LOPDP ECUADOR)
  // ═══════════════════════════════════════════════════════════════
  const PrivacyContent = () => (
    <div className="tab-content-inner legal-content" data-aos="fade-up">
      <div className="legal-sections">
        <section className="legal-section">
          <h3><FaBuilding className="section-icon" /> 1. Responsable del Tratamiento de Datos</h3>
          <div className="info-box">
            <p><strong>Empresa:</strong> NextUnicode Corp (UrbanQ)</p>
            <p><strong>Email:</strong> admin@nextunicodecorp.com</p>
            <p><strong>Direccion:</strong> Quito, Ecuador</p>
          </div>
          <p>
            NextUnicode Corp, como responsable del tratamiento, garantiza el cumplimiento
            de la Ley Organica de Proteccion de Datos Personales (LOPDP) de Ecuador,
            vigente desde mayo de 2023.
          </p>
        </section>

        <section className="legal-section">
          <h3><FaDatabase className="section-icon" /> 2. Datos que Recopilamos</h3>
          <div className="data-categories">
            <div className="data-category">
              <h4>Datos de Identificacion</h4>
              <ul>
                <li>Nombre completo</li>
                <li>Numero de cedula o pasaporte</li>
                <li>Correo electronico</li>
                <li>Numero de telefono</li>
              </ul>
            </div>
            <div className="data-category">
              <h4>Datos de Ubicacion</h4>
              <ul>
                <li>Direccion del condominio</li>
                <li>Numero de unidad habitacional</li>
                <li>Bloque o torre</li>
              </ul>
            </div>
            <div className="data-category">
              <h4>Datos Financieros</h4>
              <ul>
                <li>Historial de pagos de alicuotas</li>
                <li>Montos adeudados</li>
                <li>Metodos de pago utilizados</li>
              </ul>
            </div>
            <div className="data-category">
              <h4>Datos de Uso</h4>
              <ul>
                <li>Logs de actividad en la plataforma</li>
                <li>Preferencias de notificacion</li>
                <li>Historial de reservas</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h3><FaCheckCircle className="section-icon" /> 3. Finalidad del Tratamiento</h3>
          <ul>
            <li>Gestion de servicios de administracion de condominios</li>
            <li>Procesamiento de pagos de alicuotas</li>
            <li>Comunicacion de avisos y notificaciones importantes</li>
            <li>Generacion de reportes financieros y operativos</li>
            <li>Mejora continua de la plataforma</li>
            <li>Cumplimiento de obligaciones legales</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3><FaFileContract className="section-icon" /> 4. Base Legal del Tratamiento</h3>
          <p>El tratamiento de sus datos se fundamenta en:</p>
          <ul>
            <li><strong>Consentimiento del titular (Art. 7 LOPDP):</strong> Otorgado al registrarse en la plataforma</li>
            <li><strong>Ejecucion de contrato:</strong> Necesario para prestar los servicios contratados</li>
            <li><strong>Obligaciones legales:</strong> Cumplimiento de normativas fiscales y contables</li>
          </ul>
        </section>

        <section className="legal-section highlight">
          <h3><FaUserCheck className="section-icon" /> 5. Derechos del Titular (ARCO+)</h3>
          <p>Conforme a la LOPDP, usted tiene derecho a:</p>
          <div className="rights-grid">
            {[
              { icon: FaEye, title: 'Acceso', desc: 'Conocer que datos personales tenemos sobre usted' },
              { icon: FaEdit, title: 'Rectificacion', desc: 'Corregir datos incorrectos o desactualizados' },
              { icon: FaTrash, title: 'Cancelacion', desc: 'Solicitar la eliminacion de sus datos' },
              { icon: FaBan, title: 'Oposicion', desc: 'Oponerse al tratamiento de sus datos' },
              { icon: FaExchangeAlt, title: 'Portabilidad', desc: 'Recibir sus datos en formato electronico' },
              { icon: FaRobot, title: 'No Automatizacion', desc: 'No ser objeto de decisiones automatizadas' }
            ].map((right, index) => (
              <div className="right-item" key={index}>
                <right.icon className="right-icon" />
                <div>
                  <h4>{right.title}</h4>
                  <p>{right.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="legal-section">
          <h3><FaClock className="section-icon" /> 6. Tiempo de Conservacion de Datos</h3>
          <ul>
            <li>Los datos se conservan mientras dure la relacion contractual</li>
            <li>Datos eliminados a solicitud del usuario (salvo obligaciones legales)</li>
            <li>Maximo 5 años para fines legales y contables</li>
            <li>Logs de seguridad: 2 anos</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3><FaGlobe className="section-icon" /> 7. Transferencia de Datos</h3>
          <ul>
            <li><strong>No vendemos</strong> sus datos personales a terceros</li>
            <li>Solo compartimos con procesadores de pago (PayPal) bajo contrato de confidencialidad</li>
            <li>Transferencias internacionales solo con garantias adecuadas (Art. 42 LOPDP)</li>
            <li>Servidores ubicados en centros de datos certificados</li>
          </ul>
        </section>

        <section className="legal-section">
          <h3><FaLock className="section-icon" /> 8. Medidas de Seguridad</h3>
          <div className="security-measures">
            <div className="measure">
              <FaShieldAlt className="measure-icon" />
              <span>Cifrado de datos en transito y reposo (SSL/TLS)</span>
            </div>
            <div className="measure">
              <FaUserCheck className="measure-icon" />
              <span>Control de acceso basado en roles</span>
            </div>
            <div className="measure">
              <FaDatabase className="measure-icon" />
              <span>Copias de seguridad diarias</span>
            </div>
            <div className="measure">
              <FaEye className="measure-icon" />
              <span>Auditorias de seguridad periodicas</span>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h3><FaEnvelope className="section-icon" /> 9. Como Ejercer sus Derechos</h3>
          <div className="info-box accent">
            <p><strong>Email:</strong> admin@nextunicodecorp.com</p>
            <p><strong>Asunto:</strong> Solicitud de Derechos ARCO - [Su Nombre]</p>
            <p><strong>Plazo de respuesta:</strong> 15 dias habiles</p>
          </div>
          <p>
            Su solicitud debe incluir: nombre completo, cedula, descripcion del derecho
            que desea ejercer y datos de contacto.
          </p>
        </section>

        <section className="legal-section">
          <h3><FaBell className="section-icon" /> 10. Actualizaciones a esta Politica</h3>
          <p>
            Nos reservamos el derecho de actualizar esta politica. Los cambios significativos
            seran notificados por correo electronico con al menos 30 dias de anticipacion.
            La fecha de ultima actualizacion siempre sera visible en la parte superior de este documento.
          </p>
        </section>
      </div>
    </div>
  );

  // ═══════════════════════════════════════════════════════════════
  // CONTENIDO: DISCLAIMER
  // ═══════════════════════════════════════════════════════════════
  const DisclaimerContent = () => (
    <div className="tab-content-inner legal-content" data-aos="fade-up">
      <div className="legal-sections">
        <section className="legal-section disclaimer-section">
          <h3>Informacion General</h3>
          <p>
            La informacion proporcionada en la plataforma UrbanQ es unicamente para
            fines informativos generales. Aunque nos esforzamos por mantener la informacion
            actualizada y correcta, no hacemos representaciones o garantias de ningun tipo,
            expresas o implicitas, sobre la integridad, exactitud, confiabilidad, idoneidad
            o disponibilidad de la plataforma o la informacion contenida en ella.
          </p>
        </section>

        <section className="legal-section disclaimer-section">
          <h3>No Constituye Asesoria Profesional</h3>
          <p>
            El contenido de UrbanQ <strong>no constituye</strong> asesoria legal, financiera,
            contable o profesional de ningun tipo. Para decisiones importantes relacionadas
            con su condominio o situacion financiera, le recomendamos consultar con
            profesionales calificados en las areas correspondientes.
          </p>
        </section>

        <section className="legal-section disclaimer-section">
          <h3>Sin Garantia de Resultados</h3>
          <p>
            UrbanQ no garantiza resultados especificos del uso de la plataforma.
            Los resultados pueden variar segun multiples factores, incluyendo pero no
            limitado a: la participacion de los residentes, la gestion del administrador,
            y las condiciones particulares de cada condominio.
          </p>
        </section>

        <section className="legal-section disclaimer-section">
          <h3>Limitacion de Responsabilidad</h3>
          <ul>
            <li>No somos responsables por errores u omisiones en el contenido</li>
            <li>No garantizamos disponibilidad ininterrumpida del servicio</li>
            <li>No somos responsables por perdidas derivadas del uso de la plataforma</li>
            <li>No asumimos responsabilidad por fallos tecnicos fuera de nuestro control</li>
            <li>Las interrupciones por mantenimiento seran notificadas con anticipacion</li>
          </ul>
        </section>

        <section className="legal-section disclaimer-section">
          <h3>Responsabilidad del Usuario</h3>
          <p>
            El usuario es responsable de:
          </p>
          <ul>
            <li>Verificar la exactitud de los datos que ingresa en la plataforma</li>
            <li>Mantener actualizados sus datos de contacto y financieros</li>
            <li>Revisar periodicamente los avisos y notificaciones</li>
            <li>Reportar cualquier error o inconsistencia que detecte</li>
            <li>Mantener la seguridad de sus credenciales de acceso</li>
          </ul>
        </section>

        <section className="legal-section disclaimer-section">
          <h3>Enlaces Externos</h3>
          <p>
            La plataforma puede contener enlaces a sitios web externos (como pasarelas
            de pago). UrbanQ no tiene control sobre el contenido y practicas de privacidad
            de estos sitios y no asume responsabilidad por ellos. Le recomendamos revisar
            las politicas de privacidad de cualquier sitio externo que visite.
          </p>
        </section>

        <section className="legal-section disclaimer-section">
          <h3>Cambios en el Servicio</h3>
          <p>
            Nos reservamos el derecho de modificar, suspender o descontinuar cualquier
            aspecto del servicio en cualquier momento, con o sin previo aviso. No seremos
            responsables ante usted o terceros por cualquier modificacion, suspension o
            discontinuacion del servicio.
          </p>
        </section>

        <section className="legal-section disclaimer-section contact-box">
          <h3>Contacto</h3>
          <p>
            Si tiene preguntas sobre este disclaimer o cualquier aspecto de nuestro
            servicio, no dude en contactarnos:
          </p>
          <div className="contact-info-box">
            <p><FaEnvelope /> admin@nextunicodecorp.com</p>
            <p><FaPhone /> +593 99 534 6662</p>
            <p><FaMapMarkerAlt /> Quito, Ecuador</p>
          </div>
        </section>
      </div>
    </div>
  );

  // Renderizar contenido segun tab activo
  const renderContent = () => {
    switch (activeTab) {
      case 'about':
        return <AboutContent />;
      case 'terms':
        return <TermsContent />;
      case 'privacy':
        return <PrivacyContent />;
      case 'disclaimer':
        return <DisclaimerContent />;
      default:
        return <AboutContent />;
    }
  };

  return (
    <div className="recursos-page">
      {/* Animated Background */}
      <div className="animated-background"></div>

      {/* Hero Section */}
      <section className="recursos-hero">
        <Container>
          <div className="hero-content" data-aos="fade-up">
            <h1 className="hero-title">Recursos</h1>
            <p className="hero-subtitle">
              Informacion legal y sobre nuestra empresa
            </p>
          </div>
        </Container>
      </section>

      {/* Tabs Navigation */}
      <section className="tabs-section">
        <Container>
          <div className="tabs-container" data-aos="fade-up">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <tab.icon className="tab-icon" />
                <span className="tab-label">{tab.label}</span>
              </button>
            ))}
          </div>
        </Container>
      </section>

      {/* Tab Content */}
      <section className="content-section">
        <Container>
          <div className="content-container">
            {renderContent()}
          </div>
        </Container>
      </section>
    </div>
  );
}

export default Recursos;